import { MenuItem, ProductChannel } from '@core/models';

export interface MenuItemProductView {
	product: ProductChannel | null;
	nombre: string | undefined;
	imagen: string | null | undefined;
	descripcion: string | undefined;
}

export function mapMenuItemProduct(item: MenuItem | null): MenuItemProductView {
	const product = item?.productosCanal?.[0] ?? null;

	return {
		product,
		nombre: product?.nombre,
		imagen: product?.imagen,
		descripcion: product?.descripcion,
	};
}
